import { render, staticRenderFns } from "./tourComponent.vue?vue&type=template&id=42c81e1a&"
import script from "./tourComponent.vue?vue&type=script&lang=js&"
export * from "./tourComponent.vue?vue&type=script&lang=js&"
import style0 from "./tourComponent.vue?vue&type=style&index=0&id=42c81e1a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports